/**
 * API path constants for role recommendations
 * Centralized to eliminate duplication and ensure consistency
 */

// Base API path for all role recommendations endpoints
export const API_PATH_BASE = '/ECMv6/api/intelligence/roleRecommendations';

// Specific endpoint paths
export const ROLES_PATH = `${API_PATH_BASE}/roles`;
export const ROLES_FILTER_OPTIONS_PATH = `${API_PATH_BASE}/roles/filter-options`;
export const SUMMARY_PATH = `${API_PATH_BASE}/summary`;
